import { i18n } from '@/i18n'
export default [
  {
    path: 'configurations',
    name: 'configurationssa',
    redirect: { name: 'configurations/distributors' }
  },
  {
    path: 'configurations',
    name: 'configurations',
    redirect: { name: 'configurations/general' }
  },
  {
    path: 'configurations/users',
    name: 'configurations/users',
    component: () => import('@/views/configuration/Users.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('app.users') }
  },
  {
    path: 'configurations/locations',
    name: 'configurations/locations',
    component: () => import('@/views/configuration/Locations.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('app.locations') }
  },
  {
    path: 'configurations/template/companies',
    name: 'configurations/template/companies',
    component: () => import('@/views/configuration/Template.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('app.template') }
  },
  {
    path: 'configurations/template/groups',
    name: 'configurations/template/groups',
    component: () => import('@/views/configuration/TemplateGroup.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('app.template_groups') }
  },
  {
    path: 'configurations/representative',
    name: 'configurations/representative',
    component: () => import('@/views/configuration/Representative.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('clients.representative') }
  },
  {
    path: 'configurations/imports',
    name: 'configurations/imports',
    component: () => import('@/views/configuration/Importaciones.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('imports.imports') }
  },
  {
    path: 'configurations/documentmaster',
    name: 'configurations/documentmaster',
    component: () => import('@/views/configuration/MaestroDocumentos.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('documentmaster.documentmaster') }
  },
  {
    path: 'configurations/users/:id/details',
    name: 'configurations/users/details',
    component: () => import('@/views/configuration/User.vue'),
    meta: { secondaryMenu: 'configurations/users', registerNavFromMenu: false, title: i18n.t('app.user_detail') }
  },
  {
    path: 'configurations/users/profile',
    name: 'configurations/users/profile',
    component: () => import('@/views/configuration/UserProfile.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('app.user_profile') }
  },
  {
    path: 'configurations/users/:id/companies',
    name: 'configurations/users/companies',
    component: () => import('@/views/configuration/Companies.vue'),
    meta: { secondaryMenu: 'configurations/users', registerNavFromMenu: false, title: i18n.t('app.companies_link') }
  },
  {
    path: 'configurations/users/:id/groups',
    name: 'configurations/users/groups',
    component: () => import('@/views/configuration/GroupsByUser.vue'),
    meta: { secondaryMenu: 'configurations/users', registerNavFromMenu: false, title: i18n.t('app.groups_link') }
  },
  {
    path: 'configurations/users/:id/status',
    name: 'configurations/users/status',
    component: () => import('@/views/configuration/StatusByUser.vue'),
    meta: { secondaryMenu: 'configurations/users', registerNavFromMenu: false, title: i18n.t('configurations.status_link') }
  },
  {
    path: 'configurations/users/:id/historical',
    name: 'configurations/users/historical',
    component: () => import('@/views/historical/UserHistorical.vue'),
    meta: { secondaryMenu: 'configurations/users', registerNavFromMenu: false, title: i18n.t('historical.by_user') }
  },
  {
    path: 'configurations/locations/:id/details',
    name: 'configurations/locations/details',
    component: () => import('@/views/configuration/Location.vue'),
    meta: { secondaryMenu: 'configurations/locations', registerNavFromMenu: false }
  },
  {
    path: 'configurations/clients',
    name: 'configurations/clients',
    component: () => import('@/views/clients/Clients.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('app.clients') }
  },
  {
    path: 'configurations/general',
    name: 'configurations/general',
    component: () => import('@/views/configuration/ClientAdmin.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('configurations.config_admin') }
  },
  {
    path: 'configurations/courtesydaysaeat',
    name: 'configurations/courtesydaysaeat',
    component: () => import('@/views/clients/CourtesyDaysAEAT.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('clients.courtesydaysaeat') }
  },
  {
    path: 'configurations/clients/:id/details',
    name: 'configurations/clients/details',
    component: () => import('@/views/clients/Client.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, title: i18n.t('app.client_detail') }
  },
  {
    path: 'configurations/clients/:id/locations',
    name: 'configurations/clients/locations',
    component: () => import('@/views/clients/LocationsByClient.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, title: i18n.t('app.locations_link') }
  },
  {
    path: 'configurations/clients/:id/template/companies',
    name: 'configurations/clients/template/companies',
    component: () => import('@/views/configuration/Template.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, title: i18n.t('app.template') }
  },
  {
    path: 'configurations/clients/:id/template/groups',
    name: 'configurations/clients/template/groups',
    component: () => import('@/views/configuration/TemplateGroup.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, title: i18n.t('app.template_groups') }
  },
  {
    path: 'configurations/clients/:id/representative',
    name: 'configurations/clients/representative',
    component: () => import('@/views/configuration/Representative.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, title: i18n.t('clients.representative') }
  },
  {
    path: 'configurations/clients/:id/courtesydaysaeat',
    name: 'configurations/clients/courtesydaysaeat',
    component: () => import('@/views/clients/CourtesyDaysAEAT.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, title: i18n.t('clients.courtesydaysaeat') }
  },
  {
    path: 'configurations/clients/:id/modules',
    name: 'configurations/clients/modules',
    component: () => import('@/views/clients/Modules.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, title: i18n.t('clients.modules') }
  },
  {
    path: 'configurations/clients/:id/configaad',
    name: 'configurations/clients/configaad',
    component: () => import('@/views/clients/ConfigAAD.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, title: i18n.t('clients.config_aad') }
  },
  {
    path: 'configurations/clients/:id/configsaml2',
    name: 'configurations/clients/configsaml2',
    component: () => import('@/views/clients/ConfigSAML2.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, title: i18n.t('clients.config_saml2') }
  },
  {
    path: 'configurations/clients/:id/historical',
    name: 'configurations/clients/historical',
    component: () => import('@/views/historical/ClientHistorical.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, title: i18n.t('historical.by_client') }
  },
  {
    path: 'configurations/groups',
    name: 'configurations/groups',
    component: () => import('@/views/configuration/Groups.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('app.groups') }
  },
  {
    path: 'configurations/groups/:id/details',
    name: 'configurations/groups/details',
    component: () => import('@/views/configuration/Group.vue'),
    meta: { secondaryMenu: 'configurations/groups', registerNavFromMenu: false, title: i18n.t('app.group_detail') }
  },
  {
    path: 'configurations/groups/:id/users',
    name: 'configurations/groups/users',
    component: () => import('@/views/configuration/UsersByGroup.vue'),
    meta: { secondaryMenu: 'configurations/groups', registerNavFromMenu: false, title: i18n.t('app.users_link') }
  },
  {
    path: 'configurations/groups/:id/companies',
    name: 'configurations/groups/companies',
    component: () => import('@/views/configuration/CompaniesByGroup.vue'),
    meta: { secondaryMenu: 'configurations/groups', registerNavFromMenu: false, title: i18n.t('app.companies_link') }
  },
  {
    path: 'configurations/groups/:id/status',
    name: 'configurations/groups/status',
    component: () => import('@/views/configuration/StatusByGroup.vue'),
    meta: { secondaryMenu: 'configurations/groups', registerNavFromMenu: false, title: i18n.t('configurations.status_link') }
  },
  {
    path: 'configurations/groups/:id/rules',
    name: 'configurations/groups/rules',
    component: () => import('@/views/configuration/RulesByGroup.vue'),
    meta: { secondaryMenu: 'configurations/groups', registerNavFromMenu: false, title: i18n.t('app.groups_rules') }
  },
  {
    path: 'configurations/groups/:id/groups',
    name: 'configurations/groups/groups',
    component: () => import('@/views/configuration/GroupsByGroup.vue'),
    meta: { secondaryMenu: 'configurations/groups', registerNavFromMenu: false, title: i18n.t('app.groups_groups') }
  },
  {
    path: 'configurations/groups/:id/historical',
    name: 'configurations/groups/historical',
    component: () => import('@/views/historical/GroupHistorical.vue'),
    meta: { secondaryMenu: 'configurations/groups', registerNavFromMenu: false, title: i18n.t('historical.by_group') }
  },
  {
    path: 'configurations/rules',
    name: 'configurations/rules',
    component: () => import('@/views/configuration/Rules.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('app.rules') }
  },
  {
    path: 'configurations/rules/:id/details',
    name: 'configurations/rules/details',
    component: () => import('@/views/configuration/Rule.vue'),
    meta: { secondaryMenu: 'configurations/rules', registerNavFromMenu: false, title: i18n.t('app.rule_detail') }
  },
  {
    path: 'configurations/rules/:id/groups',
    name: 'configurations/rules/groups',
    component: () => import('@/views/configuration/GroupsByRule.vue'),
    meta: { secondaryMenu: 'configurations/rules', registerNavFromMenu: false, title: i18n.t('app.groups_link') }
  },
  {
    path: 'configurations/rules/:id/emails',
    name: 'configurations/rules/emails',
    component: () => import('@/views/configuration/EmailsByRule.vue'),
    meta: { secondaryMenu: 'configurations/rules', registerNavFromMenu: false, title: i18n.t('app.emails_link') }
  },
  {
    path: 'configurations/rules/:id/metadata',
    name: 'configurations/rules/metadata',
    component: () => import('@/views/configuration/MetadataByRule.vue'),
    meta: { secondaryMenu: 'configurations/rules', registerNavFromMenu: false, title: i18n.t('app.metadata') }
  },
  {
    path: 'configurations/rules/:id/historical',
    name: 'configurations/rules/historical',
    component: () => import('@/views/historical/RuleHistorical.vue'),
    meta: { secondaryMenu: 'configurations/rules', registerNavFromMenu: false, title: i18n.t('historical.by_rule') }
  },
  {
    path: 'configurations/orgprovinces',
    name: 'configurations/orgprovinces',
    component: () => import('@/views/configuration/OrgProvinces.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('app.orgprovinces') }
  },
  {
    path: 'configurations/orgprovinces/:id/details',
    name: 'configurations/orgprovinces/details',
    component: () => import('@/views/configuration/OrgProvince.vue'),
    meta: { secondaryMenu: 'configurations/orgprovinces', registerNavFromMenu: false, title: i18n.t('app.orgprovince_detail') }
  },
  {
    path: 'configurations/orgprovinces/:id/historical',
    name: 'configurations/orgprovinces/historical',
    component: () => import('@/views/historical/OrgProvinceHistorical.vue'),
    meta: { secondaryMenu: 'configurations/orgprovinces', registerNavFromMenu: false, title: i18n.t('historical.by_orgprovince') }
  },
  {
    path: 'configurations/apirequests',
    name: 'configurations/apirequests',
    component: () => import('@/views/configuration/APIRequests.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('app.apirequests') }
  },
  {
    path: 'configurations/apirequests/:id/details',
    name: 'configurations/apirequests/details',
    component: () => import('@/views/configuration/APIRequest.vue'),
    meta: { secondaryMenu: 'configurations/apirequests', registerNavFromMenu: false, title: i18n.t('app.apirequest_detail') }
  },
  {
    path: 'configurations/apirequests/:id/metadata',
    name: 'configurations/apirequests/metadata',
    component: () => import('@/views/configuration/APIRequestMetadata.vue'),
    meta: { secondaryMenu: 'configurations/apirequests', registerNavFromMenu: false, title: i18n.t('app.apirequest_metadata') }
  },
  {
    path: 'configurations/apirequests/:id/historical',
    name: 'configurations/apirequests/historical',
    component: () => import('@/views/historical/APIRequestHistorical.vue'),
    meta: { secondaryMenu: 'configurations/apirequests', registerNavFromMenu: false, title: i18n.t('historical.by_apirequest') }
  },
  {
    path: 'configurations/configflow',
    name: 'configurations/configflow',
    component: () => import('@/views/configuration/ConfigFlows.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('app.configflow') }
  },
  {
    path: 'configurations/configflow/:id/details',
    name: 'configurations/configflow/details',
    component: () => import('@/views/configuration/ConfigFlow.vue'),
    meta: { secondaryMenu: 'configurations/configflow', registerNavFromMenu: false, title: i18n.t('app.configflow_detail') }
  },
  {
    path: 'configurations/configflow/:id/historical',
    name: 'configurations/configflow/historical',
    component: () => import('@/views/historical/ConfigFlowHistorical.vue'),
    meta: { secondaryMenu: 'configurations/configflow', registerNavFromMenu: false, title: i18n.t('historical.by_configlow') }
  },
  // {
  //   path: 'configurations/grouping/companies/redirect',
  //   name: 'configurations/grouping/companies/redirect',
  //   redirect: { name: 'configurations/grouping/companies' }
  // },
  // Horario descarga
  {
    path: 'configurations/downloadschedule',
    name: 'configurations/downloadschedule',
    component: () => import('@/views/configuration/HorarioDescarga.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('clients.horario_descarga') }
  },
  {
    path: 'configurations/clients/:id/downloadschedule',
    name: 'configurations/clients/downloadschedule',
    component: () => import('@/views/configuration/HorarioDescarga.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, title: i18n.t('clients.horario_descarga') }
  },
  // Calendario festivos
  {
    path: 'configurations/holidaycalendar',
    name: 'configurations/holidaycalendar',
    component: () => import('@/views/configuration/CalendarioFestivos.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('clients.calendario_festivos') }
  },
  {
    path: 'configurations/clients/:id/holidaycalendar',
    name: 'configurations/clients/holidaycalendar',
    component: () => import('@/views/configuration/CalendarioFestivos.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, title: i18n.t('clients.calendario_festivos') }
  },
  // Asistencia IA
  {
    path: 'configurations/configaiassist',
    name: 'configurations/configaiassist',
    component: () => import('@/views/configuration/ConfigAIAssist.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('clients.ai_assist') }
  },
  {
    path: 'configurations/clients/:id/configaiassist',
    name: 'configurations/clients/configaiassist',
    component: () => import('@/views/configuration/ConfigAIAssist.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, title: i18n.t('clients.ai_assist') }
  },

  // Personalization
  {
    path: 'configurations/personalization',
    name: 'configurations/personalization',
    component: () => import('@/views/configuration/Personalization.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('clients.personalization') }
  },
  {
    path: 'configurations/clients/:id/personalization',
    name: 'configurations/clients/personalization',
    component: () => import('@/views/configuration/Personalization.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, title: i18n.t('clients.personalization_client') }
  },
  // Grouping
  {
    path: 'configurations/grouping/:id/companies',
    name: 'configurations/grouping/companies',
    component: () => import('@/views/grouping/Companies.vue'),
    meta: { secondaryMenu: 'configurations/grouping', registerNavFromMenu: false, title: i18n.t('grouping.grouping_companies') }
  },
  {
    path: 'configurations/grouping/:id/locations',
    name: 'configurations/grouping/locations',
    component: () => import('@/views/grouping/Locations.vue'),
    meta: { secondaryMenu: 'configurations/grouping', registerNavFromMenu: false, title: i18n.t('grouping.grouping_locations') }
  },
  {
    path: 'configurations/grouping/:id/values',
    name: 'configurations/grouping/values',
    component: () => import('@/views/grouping/Values.vue'),
    meta: { secondaryMenu: 'configurations/grouping', registerNavFromMenu: false, title: i18n.t('grouping.grouping_values') }
  },
  {
    path: 'configurations/grouping/:id/agencies',
    name: 'configurations/grouping/agencies',
    component: () => import('@/views/grouping/Agencies.vue'),
    meta: { secondaryMenu: 'configurations/grouping', registerNavFromMenu: false, title: i18n.t('grouping.grouping_agencies') }
  },
  {
    path: 'configurations/grouping/companies/main',
    name: 'configurations/grouping/companies/main',
    component: () => import('@/views/grouping/Companies.vue'),
    meta: { secondaryMenu: 'configurations/grouping/main', registerNavFromMenu: false, title: i18n.t('grouping.grouping_companies') }
  },
  {
    path: 'configurations/grouping/locations/main',
    name: 'configurations/grouping/locations/main',
    component: () => import('@/views/grouping/Locations.vue'),
    meta: { secondaryMenu: 'configurations/grouping/main', registerNavFromMenu: false, title: i18n.t('grouping.grouping_locations') }
  },
  {
    path: 'configurations/grouping/values/main',
    name: 'configurations/grouping/values/main',
    component: () => import('@/views/grouping/Values.vue'),
    meta: { secondaryMenu: 'configurations/grouping/main', registerNavFromMenu: false, title: i18n.t('grouping.grouping_values') }
  },
  {
    path: 'configurations/grouping/agencies/main',
    name: 'configurations/grouping/agencies/main',
    component: () => import('@/views/grouping/Agencies.vue'),
    meta: { secondaryMenu: 'configurations/grouping/main', registerNavFromMenu: false, title: i18n.t('grouping.grouping_agencies') }
  },
  // Distribuidores
  {
    path: 'configurations/template/clients',
    name: 'configurations/template/clients',
    component: () => import('@/views/distributors/TemplateClient.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('distributors.template_clients') }
  },
  {
    path: 'configurations/template/clientspersonalization',
    name: 'configurations/template/clientspersonalization',
    component: () => import('@/views/distributors/TemplateClientPersonalization.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('distributors.template_clients_personalization') }
  },
  {
    path: 'configurations/template/clientsdownloadschedule',
    name: 'configurations/template/clientsdownloadschedule',
    component: () => import('@/views/distributors/TemplateHorarioDescarga.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('distributors.template_clients_horario_descarga') }
  },
  {
    path: 'configurations/template/clientsholidaycalendar',
    name: 'configurations/template/clientsholidaycalendar',
    component: () => import('@/views/distributors/TemplateCalendarioFestivos.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('distributors.template_clients_calendario_festivos') }
  },
  {
    path: 'configurations/distributors',
    name: 'configurations/distributors',
    component: () => import('@/views/distributors/Distributors.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('distributors.header') }
  },
  {
    path: 'configurations/distributors/:id/details',
    name: 'configurations/distributors/details',
    component: () => import('@/views/distributors/Distributor.vue'),
    meta: { secondaryMenu: 'configurations/distributors', registerNavFromMenu: false, title: i18n.t('distributors.distributor') }
  },
  {
    path: 'configurations/distributors/:id/modules',
    name: 'configurations/distributors/modules',
    component: () => import('@/views/distributors/Modules.vue'),
    meta: { secondaryMenu: 'configurations/distributors', registerNavFromMenu: false, title: i18n.t('clients.modules') }
  },
  {
    path: 'configurations/distributors/:id/locations',
    name: 'configurations/distributors/locations',
    component: () => import('@/views/distributors/LocationsByDistributor.vue'),
    meta: { secondaryMenu: 'configurations/distributors', registerNavFromMenu: false, title: i18n.t('app.locations_hired') }
  },
  {
    path: 'configurations/distributors/:id/template/clients',
    name: 'configurations/distributors/template/clients',
    component: () => import('@/views/distributors/TemplateClient.vue'),
    meta: { secondaryMenu: 'configurations/distributors', registerNavFromMenu: false, title: i18n.t('distributors.template_clients') }
  },
  {
    path: 'configurations/distributors/:id/template/clientspersonalization',
    name: 'configurations/distributors/template/clientspersonalization',
    component: () => import('@/views/distributors/TemplateClientPersonalization.vue'),
    meta: { secondaryMenu: 'configurations/distributors', registerNavFromMenu: false, title: i18n.t('distributors.template_clients_personalization') }
  },
  {
    path: 'configurations/distributors/:id/template/clientsholidaycalendar',
    name: 'configurations/distributors/template/clientsholidaycalendar',
    component: () => import('@/views/distributors/TemplateCalendarioFestivos.vue'),
    meta: { secondaryMenu: 'configurations/distributors', registerNavFromMenu: false, title: i18n.t('distributors.template_clients_horario_descarga') }
  },
  {
    path: 'configurations/distributors/:id/template/clientsdownloadschedule',
    name: 'configurations/distributors/template/clientsdownloadschedule',
    component: () => import('@/views/distributors/TemplateHorarioDescarga.vue'),
    meta: { secondaryMenu: 'configurations/distributors', registerNavFromMenu: false, title: i18n.t('distributors.template_clients_calendario_festivos') }
  },
  {
    path: 'configurations/distributors/:id/historical',
    name: 'configurations/distributors/historical',
    component: () => import('@/views/historical/DistributorHistorical.vue'),
    meta: { secondaryMenu: 'configurations/distributors', registerNavFromMenu: false, title: i18n.t('historical.by_distributor') }
  },
  {
    path: 'procedings',
    name: 'procedings',
    component: () => import('@/views/configuration/Procedings.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('procedings.title') }
  },
  {
    path: 'procedings/:id/:idNEO/details',
    name: 'procedings/details',
    component: () => import('@/views/configuration/Proceding.vue'),
    meta: { secondaryMenu: 'procedings', registerNavFromMenu: false, title: i18n.t('procedings.title') }
  },
  {
    path: 'procedings/:id/:idNEO/historical',
    name: 'procedings/historical',
    component: () => import('@/views/historical/ProcedingHistorical.vue'),
    meta: { secondaryMenu: 'procedings', registerNavFromMenu: false, title: i18n.t('historical.by_proceding') }
  },

]
